import { render, staticRenderFns } from "./PostLinkedin.vue?vue&type=template&id=aaf6f780&"
import script from "./PostLinkedin.vue?vue&type=script&lang=js&"
export * from "./PostLinkedin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports